import React,{useEffect} from 'react'
import SidebarInf03 from '../../components/sidebar/SidebarInf03'
import 'highlight.js/styles/atom-one-dark.css';
import hljs from 'highlight.js';

const Skrphp = () => {

  useEffect(() => {
    hljs.addPlugin({
        'after:highlightElement': ({ result, el }) => {
            const lines = document.createElement('div');
            if (!result.value.includes('<span class="line-num">')) {
                lines.innerHTML = result.value.replace(/^/gm, '<span class="line-num"></span>');
            }
            el.replaceChildren(...lines.childNodes);
        }
    });


    if (!document.querySelector('.hljs')) {
      hljs.highlightAll();
  }
   
  });


  return (
    <div id='rozwiazaniainf03'>

    <SidebarInf03></SidebarInf03>

        <div id="rozwiazanieustawienie">
          <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <h1>Skrypt PHP na egzaminie powtórka</h1>
            
            <hr></hr>
            <section>
              <h2>Spis Treści</h2>
              <ol className='listmargin'>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptphp#zmiennephp">Zmienne w PHP</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptphp#inswarunkowe">Instrukcje Warunkowe</a>
                  <ul>
                    <li>Podstawowa składnia instrukcji if</li>
                    <li>Instrukcja if-else</li>
                    <li>Instrukcja if-elseif-else</li>
                    <li>Zagnieżdżone instrukcje if</li>
                    <li>Warunki logiczne</li>
                    <li>Operator trójargumentowy (?:)</li>
                  </ul>
                </li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptphp#petlephp">Pętle w PHP</a>
                  <ul>
                    <li>Pętla while</li>
                    <li>Pętla do-while</li>
                    <li>Pętla for</li>
                    <li>Pętla foreach</li>
                    <li>Instrukcje sterujące</li>
                    <li>Zagnieżdżanie pętli</li>
                  </ul>
                </li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptphp#switchphp">Instrukcja switch w PHP</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptphp#funkcjephp">Funkcje w PHP</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptphp#laczeniephp">Łączenie z bazą danych</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptphp#wysylaniephp">Wysyłanie zapytań do SQL</a>
                  <ul>
                    <li>Zapytanie SELECT</li>
                    <li>Zapytanie INSERT</li>
                    <li>Zapytanie UPDATE</li>
                    <li>Zapytanie DELETE</li>
                  </ul>
                </li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptphp#isemphp">Funkcja isset() vs empty() w PHP</a></li>
              </ol>
            </section>
            <hr></hr>
            <section id="zmiennephp">
              <h2>Zmienne w PHP</h2>
              <p>W PHP zmienne są deklarowane za pomocą znaku <b>$</b> przed nazwą zmiennej. 
                Nazwa zmiennej musi zaczynać się od litery lub podkreślenia _, a następnie może zawierać litery, cyfry oraz podkreślenia.
                Również PHP jest <b>językiem dynamicznie typowanym</b>, co oznacza, że typ zmiennej jest określany automatycznie podczas przypisywania wartości.
                </p>
              <pre>
                <code>
                  {`<?php
//zmienna string
$mojtekst = "Witaj, świecie!";
//zmienna int
$ulubionaliczba = 7;
//zmienna float
$sredniaocen = 5.67;
//zmienna boolen
$wartownik = true;
//zmienna listy
$biegi = array(1, 2, 3, 4, 5, 6);

//zmienna obiektu
class Samochod {
    public $marka;
    public function __construct($marka) {
        $this->marka = $marka;
    }
}
$obiekt = new Samochod("Toyota");
?>`}
                </code>
              </pre>
              <h4>Operacje na zmiennych</h4>
              <p>PHP oferuje wiele operacji, które można wykonywać na zmiennych. Do najważniejszych z nich należą:</p>
              <ul className='listmargin'>
                  <li><p>Przypisanie wartości: Umożliwia przypisanie wartości do zmiennej.</p>
                  <pre>
                <code>
                  {`$a = 5;`}
                </code>
              </pre>
                  </li>
                  <li><p>Konkatenacja (łączenie) ciągów znaków: Za pomocą operatora "."</p>
                  <pre>
                <code>
                  {`$hello = "Hello, ";
$world = "World!";
$helloWorld = $hello . $world; // Wynik: "Hello, World!"`}
                </code>
              </pre>
                  </li>
                  <li><p>Operacje arytmetyczne: Dodawanie, odejmowanie, mnożenie, dzielenie.</p>
                  <pre>
                <code>
                  {`$x = 10;
$y = 5;
$sum = $x + $y; // Wynik: 15
$difference = $x - $y; // Wynik: 5
$product = $x * $y; // Wynik: 50
$quotient = $x / $y; // Wynik: 2`}
                </code>
              </pre>
                  </li>
                  <li><p>Operacje logiczne: AND, OR, NOT.</p>
                  <pre>
                <code>
                  {`$a = true;
$b = false;
$result = $a && $b; // Wynik: false
$result = $a || $b; // Wynik: true
$result = !$a; // Wynik: false`}
                </code>
              </pre>
                  </li>
  
                </ul>
            </section>
            <hr></hr>
            <section id="inswarunkowe">
                    <h2>Instrukcje Warunkowe</h2>
                    <p>Instrukcja warunkowa if jest jednym z podstawowych narzędzi w każdym języku programowania, 
                      w tym również w PHP. Pozwala ona na wykonywanie określonego fragmentu kodu tylko wtedy, gdy spełniony jest dany warunek logiczny. 
                      Dzięki temu możemy kontrolować przepływ wykonywania programu w zależności od zmieniających się okoliczności.</p>
                    <h4>Podstawowa składnia instrukcji if</h4>
                    <p>Podstawowa składnia instrukcji if w PHP wygląda następująco:</p>
                    <pre><code>
                      {`<?php
if (warunek) {
    // kod do wykonania, gdy warunek jest prawdziwy
}
?>`}
                      </code></pre>
                      <p>Przykład:</p>
                      <pre><code>
                        {`<?php
$liczba = 10;

if ($liczba > 5) {
    echo "Liczba jest większa niż 5";
}
?>`}
                        </code></pre>
                        <h4>Instrukcja if-else</h4>
                        <p>Instrukcja if może być rozszerzona o blok else, który zostanie wykonany, gdy warunek nie jest spełniony.</p>
                        <pre><code>
                          {`<?php
if (warunek) {
    // kod do wykonania, gdy warunek jest prawdziwy
} else {
    // kod do wykonania, gdy warunek jest fałszywy
}
?>`}</code></pre>
<p>Przykład:</p>
<pre><code>{`<?php
$liczba = 3;

if ($liczba > 5) {
    echo "Liczba jest większa niż 5";
} else {
    echo "Liczba nie jest większa niż 5";
}
?>`}</code></pre>
<h4>Instrukcja if-elseif-else</h4>
<p>PHP umożliwia także sprawdzenie wielu warunków przy użyciu instrukcji elseif.
   Możemy zdefiniować tyle warunków elseif, ile potrzebujemy. Blok else na końcu jest opcjonalny.</p>
   <pre><code>{`<?php
if (warunek1) {
    // kod do wykonania, gdy warunek1 jest prawdziwy
} elseif (warunek2) {
    // kod do wykonania, gdy warunek2 jest prawdziwy
} else {
    // kod do wykonania, gdy żaden z powyższych warunków nie jest prawdziwy
}
?>`}</code></pre>
<p>Przykład:</p>
<pre><code>{`<?php
$liczba = 7;

if ($liczba > 10) {
    echo "Liczba jest większa niż 10";
} elseif ($liczba > 5) {
    echo "Liczba jest większa niż 5, ale mniejsza lub równa 10";
} else {
    echo "Liczba jest 5 lub mniejsza";
}
?>`}</code></pre>
<h4>Zagnieżdżone instrukcje if</h4>
<p>Można również zagnieżdżać instrukcje if, umieszczając jedną instrukcję if wewnątrz drugiej. 
  Jest to przydatne, gdy potrzebujemy sprawdzić wiele warunków w bardziej złożonych scenariuszach.</p>
  <pre><code>{`<?php
$liczba = 8;

if ($liczba > 5) {
    if ($liczba < 10) {
        echo "Liczba jest większa niż 5, ale mniejsza niż 10";
    } else {
        echo "Liczba jest większa niż 10";
    }
} else {
    echo "Liczba jest 5 lub mniejsza";
}
?>`}</code></pre>
<h4>Warunki logiczne</h4>
<p>Warunki w instrukcjach if mogą być złożone za pomocą operatorów logicznych:</p>
<ul className='listmargin'>
                  <li>AND (&&): Prawdziwe, gdy oba warunki są prawdziwe.</li>
                  <li>OR (||): Prawdziwe, gdy przynajmniej jeden z warunków jest prawdziwy.</li>
                  <li>NOT (!): Negacja warunku.</li>
</ul>
<p>Przykład:</p>
<pre><code>{`<?php
$liczba = 7;

if ($liczba > 5 && $liczba < 10) {
    echo "Liczba jest większa niż 5 i mniejsza niż 10";
}

if ($liczba > 10 || $liczba < 5) {
    echo "Liczba jest większa niż 10 lub mniejsza niż 5";
}

if (!($liczba > 5)) {
    echo "Liczba nie jest większa niż 5";
}
?>`}</code></pre>
<h4>Operator trójargumentowy (?:)</h4>
<p>PHP oferuje również uproszczoną formę instrukcji warunkowej, 
  znaną jako operator trójargumentowy (ternary operator). Składnia tego operatora wygląda następująco:</p>
  <pre><code>{`wartość = (warunek) ? wartość_jeśli_prawda : wartość_jeśli_fałsz;`}</code></pre>
  <p>Przykład:</p>
  <pre><code>{`<?php
$liczba = 7;
$wynik = ($liczba > 5) ? "Większa niż 5" : "Mniejsza lub równa 5";
echo $wynik;
?>`}</code></pre>
            </section>
            <hr id="petlephp"></hr>
            <section >
              <h2>Pętle w PHP</h2>
              <p>Pętle są fundamentalnym elementem każdego języka programowania, 
                umożliwiającym wykonywanie zestawu instrukcji wielokrotnie.
                 PHP oferuje kilka rodzajów pętli, które można wykorzystać w zależności od
                  konkretnych potrzeb: while, do-while, for oraz foreach. 
                Każda z nich ma swoje unikalne zastosowanie i zalety.</p>
                <h4>Pętla while</h4>
                <p>Pętla while wykonuje blok kodu tak długo, jak warunek logiczny jest spełniony. 
                  Warunek jest sprawdzany przed każdą iteracją, co oznacza, że jeśli warunek początkowo nie jest spełniony,
                   pętla nie wykona się ani razu.</p>
                   <pre><code>{`<?php
$i = 0;
while ($i < 5) {
    echo $i . "|";
    $i++;
}
?>`}</code></pre>
            <h4>Pętla do-while</h4>
            <p>Pętla do-while działa podobnie do pętli while, z tą różnicą, że warunek jest sprawdzany po wykonaniu bloku kodu. 
              Oznacza to, że pętla do-while zawsze wykona się przynajmniej raz.</p>
              <pre><code>{`<?php
$i = 0;
do {
    echo $i . "|";
    $i++;
} while ($i < 5);
?>`}</code></pre>
            <h4>Pętla for</h4>
            <p>Pętla for jest bardziej złożona i oferuje większą kontrolę nad iteracjami. Składa się z trzech części: 
              inicjalizacji, warunku oraz modyfikatora. Wszystkie te elementy są umieszczone w nawiasach okrągłych i oddzielone średnikami.</p>
              <pre><code>{`<?php
for ($i = 0; $i < 5; $i++) {
    echo $i . "|";
}
?>`}</code></pre>
<h4>Pętla foreach</h4>
<p>Pętla foreach jest specjalnie zaprojektowana do iteracji po tablicach. 
  Dla każdej wartości w tablicy pętla foreach wykonuje blok kodu. Można również uzyskać dostęp do klucza każdej wartości.</p>
  <pre><code>{`<?php
$array = array("apple", "banana", "cherry");

foreach ($array as $value) {
    echo $value . "|";
}
?>`}</code></pre>
<p>Jeśli chcemy uzyskać zarówno klucz, jak i wartość, możemy użyć następującej formy pętli foreach:</p>
<pre><code>{`<?php
$array = array("a" => "apple", "b" => "banana", "c" => "cherry");

foreach ($array as $key => $value) {
    echo $key . ": " . $value . "|";
}
?>`}</code></pre>
<h4>Instrukcje sterujące</h4>
<p>PHP oferuje również instrukcje sterujące, które można używać w obrębie pętli, takie jak break i continue.</p>
<ul className='listmargin'>
                  <li><p>break: Przerywa wykonywanie pętli i wychodzi z niej.</p>
                  <pre><code>{`<?php
for ($i = 0; $i < 10; $i++) {
    if ($i == 5) {
        break;
    }
    echo $i . "|";
}
?>
`}</code></pre></li>
                  <li><p>continue: Przerywa aktualną iterację pętli i przechodzi do następnej iteracji.</p>
                  <pre><code>{`<?php
for ($i = 0; $i < 10; $i++) {
    if ($i % 2 == 0) {
        continue;
    }
    echo $i . "|";
}
?>
`}</code></pre>
                  </li>
   
</ul>
<h4>Zagnieżdżanie pętli</h4>
<p>Pętle można zagnieżdżać, czyli umieszczać jedną pętlę wewnątrz drugiej. 
  To pozwala na tworzenie bardziej złożonych struktur iteracyjnych.</p>
  <pre><code>{`<?php
for ($i = 0; $i < 3; $i++) {
    for ($j = 0; $j < 3; $j++) {
        echo "i: $i, j: $j |";
    }
}
?>`}</code></pre>
            </section>
            <hr></hr>
            <section id="switchphp">
              <h2>Instrukcja switch w PHP</h2>
              <p>Instrukcja switch jest kolejną metodą umożliwiającą podejmowanie decyzji w kodzie PHP.
                 Jest szczególnie przydatna, gdy mamy do czynienia z wieloma warunkami dotyczącymi tej samej zmiennej.
                  W przeciwieństwie do wielu zagnieżdżonych instrukcji if-else, 
                instrukcja switch oferuje bardziej czytelny i zwięzły sposób obsługi takich przypadków.</p>
              <p>Podstawowa składnia instrukcji switch w PHP wygląda następująco:</p>
              <pre><code>{`<?php
switch (wyrażenie) {
    case wartość1:
        // kod do wykonania, gdy wyrażenie równa się wartość1
        break;
    case wartość2:
        // kod do wykonania, gdy wyrażenie równa się wartość2
        break;
    // ...
    default:
        // kod do wykonania, gdy wyrażenie nie równa się żadnej z powyższych wartości
}
?>`}</code></pre>
<p>Przykład:</p>
<pre><code>{`<?php
$dzien = "wtorek";

switch ($dzien) {
    case "poniedziałek":
        echo "Dzisiaj jest poniedziałek";
        break;
    case "wtorek":
        echo "Dzisiaj jest wtorek";
        break;
    case "środa":
        echo "Dzisiaj jest środa";
        break;
    default:
        echo "Nieznany dzień";
}
?>`}</code></pre>
            </section>
            <hr />
            <section id="funkcjephp">
              <h2>Funkcje w PHP</h2>
              <p>Funkcje w PHP są podstawowymi elementami, które pozwalają na organizowanie i wielokrotne używanie kodu.
                W skrócie funkcja to przepis na coś, np w kuchni przepis na zupę heh.
              </p>
              <h4>Definiowanie funkcji</h4>
              <pre><code>{`<?php
function nazwaFunkcji() {
    // kod do wykonania
}
?>`}</code></pre>
            <p>Przykład:</p>
            <pre><code>{`<?php
function przywitaj() {
    echo "Witaj, świecie!";
}

przywitaj(); // Wywołanie funkcji
?>`}</code></pre>
<h4>Argumenty funkcji</h4>
<p>Funkcje mogą przyjmować argumenty,
   które są wartościami przekazywanymi do funkcji podczas jej wywołania. Argumenty są definiowane w nawiasach po nazwie funkcji.</p>
   <pre><code>{`<?php
function przywitaj($imie) {
    echo "Witaj, " . $imie . "!";
}

przywitaj("Jan"); // Wywołanie funkcji z argumentem "Jan"
?>`}</code></pre>
<h4>Domyślne wartości argumentów</h4>
<p>Można również zdefiniować domyślne wartości argumentów. 
  Jeśli argument nie zostanie przekazany podczas wywołania funkcji, użyta zostanie jego domyślna wartość.</p>
  <pre><code>{`<?php
function przywitaj($imie = "gościu") {
    echo "Witaj, " . $imie . "!";
}

przywitaj(); // Witaj, gościu!
przywitaj("Jan"); // Witaj, Jan!
?>`}</code></pre>
<h4>Zwracanie wartości</h4>
<p>Funkcje mogą zwracać wartości za pomocą słowa kluczowego return.
   Po wykonaniu instrukcji return, funkcja natychmiast kończy swoje działanie.</p>
   <pre><code>{`<?php
function dodaj($a, $b) {
    return $a + $b;
}

$wynik = dodaj(2, 3); // $wynik będzie równy 5
echo $wynik;
?>`}</code></pre>
            </section>
            <hr />
            <section id="laczeniephp">
              <h2>Łączenie z bazą danych</h2>       
              <p>
                Wewnątrz pliku PHP dodaj poniższy kod, aby połączyć się z bazą danych:
              </p>
              <h4>Podejście obiektowe</h4>
              <pre>
                <code>
{`<?php
$servername = "localhost";
$username = "root";
$password = "";
$dbname = "mydatabase";

// Tworzenie połączenia
$conn = new mysqli($servername, $username, $password, $dbname);

// Sprawdzanie połączenia
if ($conn->connect_error) {
    die("Brak połączenia: " . $conn->connect_error);
}

echo "Połączono teraz możesz robić wszystko muhahhaha";

// Zamykanie połączenia
$conn->close();

?>`}
                </code>
              </pre>

              <h4>Podejście proceduralne</h4>
              <pre>
                <code>
                {`<?php
$servername = "localhost";
$username = "root";
$password = "";
$dbname = "mydatabase";

// Tworzenie połączenia
$conn = mysqli_connect($servername, $username, $password, $dbname);

// Sprawdzanie połączenia
if (!$conn) {
    die("Brak połączenia: " . mysqli_connect_error());
}

echo "Połączono teraz możesz robić wszystko muhahhaha";

// Zamykanie połączenia
mysqli_close($conn);
?>`}
                </code>
              </pre>
           
                <ul>
                  <li><code>$servername</code>: Serwer bazy danych, zazwyczaj <code>localhost</code> dla lokalnych środowisk.</li>
                  <li><code>$username</code>: Nazwa użytkownika bazy danych, zazwyczaj <code>root</code> w XAMPP.</li>
                  <li><code>$password</code>: Hasło użytkownika bazy danych, domyślnie puste w XAMPP.</li>
                  <li><code>$dbname</code>: Nazwa bazy danych, którą utworzyłeś w phpMyAdmin, na przykład <code>mydatabase</code>.</li>
                </ul>

<blockquote className="info">
    <strong>Podejście obiektowe a proceduralne</strong>
    Podejście proceduralne i obiektowe to dwa różne paradygmaty programowania. W podejściu proceduralnym programowanie polega na sekwencyjnym wykonywaniu funkcji i procedur, gdzie dane są przetwarzane krok po kroku. Przykładem jest użycie funkcji takich jak <code>mysqli_connect</code> i <code>mysqli_close</code> w PHP. Natomiast w podejściu obiektowym programowanie koncentruje się na tworzeniu obiektów, które łączą dane i metody ich przetwarzania. W PHP przykładem jest użycie klasy <code>mysqli</code> do tworzenia instancji obiektów połączenia z bazą danych. Podejście obiektowe ułatwia organizację kodu, ponowne użycie oraz jego rozszerzalność.
</blockquote>
            </section>
            <hr />
            <section id="wysylaniephp">
              <h2>Wysyłanie zapytań do SQL</h2>
              <p>PHP umożliwia wykonywanie różnorodnych zapytań SQL do baz danych, takich jak MySQL, dzięki czemu możemy manipulować danymi zapisanymi w bazie.
                 W tej sekcji omówimy, jak wysyłać zapytania SQL do bazy danych za pomocą mysqli. Pamiętaj jednak że musisz przed tym połączyć się z bazą danych, a po zakończeniu operacji najlepiej ją zamknąć </p>
              <h4>Zapytanie SELECT</h4>
              <pre><code>{`<?php
//Podejście Proceduralne
$sql = "SELECT * FROM users";
$result = mysqli_query($conn, $sql);

if (mysqli_num_rows($result) > 0) {
    while($row = mysqli_fetch_assoc($result)) {
        echo "id: " . $row["id"]. " - Name: " . $row["username"]. "<br>";
    }
} else {
    echo "Brak wyników";
}

//Podejście obiektowe

$sql = "SELECT * FROM users";
$result = $conn->query($sql);

if ($result->num_rows > 0) {
    while($row = $result->fetch_assoc()) {
        echo "id: " . $row["id"]. " - Name: " . $row["username"]. "<br>";
    }
} else {
    echo "Brak wyników";
}

?>`}</code></pre>
<h4>Zapytanie INSERT</h4>
              <pre><code>{`<?php
//Podejście Proceduralne
$sql = "INSERT INTO users (username, email) VALUES ('pawel', 'pawel@gmail.com')";

if (mysqli_query($conn, $sql)) {
    echo "Nowy rekord został utworzony";
} else {
    echo "Błąd: " . $sql . "<br>" . mysqli_error($conn);
}

//Podejście obiektowe

$sql = "INSERT INTO users (username, email) VALUES ('pawel', 'pawel@gmail.com')";

if ($conn->query($sql) === TRUE) {
    echo "Nowy rekord został utworzony";
} else {
    echo "Błąd: " . $sql . "<br>" . $conn->error;
}

?>`}</code></pre>
<h4>Zapytanie UPDATE</h4>
              <pre><code>{`<?php
//Podejście Proceduralne
$sql = "UPDATE users SET email='nowypawel@example.com' WHERE username='jacek'";

if (mysqli_query($conn, $sql)) {
    echo "Rekord został zaktualizowany";
} else {
    echo "Błąd: " . $sql . "<br>" . mysqli_error($conn);
}

//Podejście obiektowe

$sql = "UPDATE users SET email='nowypawel@example.com' WHERE username='jacek'";

if ($conn->query($sql) === TRUE) {
    echo "Rekord został zaktualizowany";
} else {
    echo "Błąd: " . $sql . "<br>" . $conn->error;
}

?>`}</code></pre>
<h4>Zapytanie DELETE</h4>
              <pre><code>{`<?php
//Podejście Proceduralne
$sql = "DELETE FROM users WHERE username='jacek'";

if (mysqli_query($conn, $sql)) {
    echo "Rekord został usunięty";
} else {
    echo "Błąd: " . $sql . "<br>" . mysqli_error($conn);
}

//Podejście obiektowe

$sql = "DELETE FROM users WHERE username='jacek'";

if ($conn->query($sql) === TRUE) {
    echo "Rekord został usunięty";
} else {
    echo "Błąd: " . $sql . "<br>" . $conn->error;
}

?>`}</code></pre>
            </section>
            <hr />
            <section>
              <h2>Pobieranie danych z formularzy w PHP</h2>
              Pobieranie danych z formularzy HTML jest jednym z podstawowych zadań na egzaminie zawodowym. PHP oferuje proste i efektywne sposoby na uzyskanie danych wprowadzonych przez użytkowników w formularzach.
              Dane te mogą być następnie przetwarzane, przechowywane w bazie danych lub używane w innych częściach aplikacji.
              <h4>Formularze HTML</h4>
              <p>Formularze HTML są podstawowym sposobem, w jaki użytkownicy mogą wprowadzać dane na stronach internetowych.
                 Każdy formularz HTML ma atrybut method, który określa, 
                jak dane zostaną przesłane do serwera, oraz atrybut action, który określa, do jakiego skryptu dane zostaną przesłane.</p>
                <p>Przykład:</p>
                <pre><code>{`<!DOCTYPE html>
<html>
<head>
   <!-- Sekcja Head -->
</head>
<body>

<form action="odbierz_dane.php" method="post">
  Imię: <input type="text" name="imie"><br>
  Email: <input type="text" name="email"><br>
  <input type="submit" value="Wyślij">
</form>

</body>
</html>`}</code></pre>
<h4>Odbieranie danych w PHP</h4>
<p>PHP oferuje dwie superglobalne tablice, które służą do pobierania danych z formularzy:</p>
<ol className='listmargin'>
  <li> $_POST - zawiera dane przesłane metodą POST.</li>
  <li> $_GET - zawiera dane przesłane metodą GET.</li>
</ol>
<h5>Metoda POST</h5>
<p>Metoda POST jest bardziej odpowiednia do przesyłania danych, które mają być bezpieczniejsze i prywatne,
   takich jak hasła czy dane osobowe.
   Dane przesłane metodą POST nie są widoczne w adresie URL.</p>
   <pre><code>{`<?php
if ($_SERVER["REQUEST_METHOD"] == "POST") {
    $imie = $_POST['imie'];
    $email = $_POST['email'];

    echo "Imię: " . htmlspecialchars($imie) . "<br>";
    echo "Email: " . htmlspecialchars($email) . "<br>";
}
?>`}</code></pre>
<h5>Metoda GET</h5>
<p>Metoda GET jest odpowiednia do przesyłania danych, które mogą być widoczne w adresie URL, takich jak parametry wyszukiwania. Dane przesłane metodą GET są widoczne w adresie URL.</p>
   <pre><code>{`<!DOCTYPE html>
<html>
<body>

<form action="odbierz_dane.php" method="get">
  Imię: <input type="text" name="imie"><br>
  Email: <input type="text" name="email"><br>
  <input type="submit" value="Wyślij">
</form>

</body>
</html>`}</code></pre>
<pre><code>{`<?php
if ($_SERVER["REQUEST_METHOD"] == "GET") {
    $imie = $_GET['imie'];
    $email = $_GET['email'];

    echo "Imię: " . htmlspecialchars($imie) . "<br>";
    echo "Email: " . htmlspecialchars($email) . "<br>";
}
?>`}</code></pre>
            </section>
            <hr />
            <section id="isemphp">
              <h2>Funkcja isset() vs empty() w PHP</h2>
              <p>W PHP funkcje isset() i empty() służą do sprawdzania zmiennych. 
                Choć obie funkcje są używane do testowania zmiennych, mają różne cele i działają inaczej.</p>
                <h4>Funkcja isset()</h4>
                <p>Funkcja isset() sprawdza, czy zmienna jest ustawiona (czy ma jakąkolwiek wartość inną niż NULL).
                   Zwraca true, jeśli zmienna istnieje i nie jest NULL, oraz false w przeciwnym razie.</p>
                   <pre><code>{`<?php
$var1 = "Witaj";
$var2 = NULL;

if (isset($var1)) {
    echo "var1 jest ustawiona i nie jest NULL.<br>";
} else {
    echo "var1 nie jest ustawiona lub jest NULL.<br>";
}

if (isset($var2)) {
    echo "var2 jest ustawiona i nie jest NULL.<br>";
} else {
    echo "var2 nie jest ustawiona lub jest NULL.<br>";
}
?>`}</code></pre>
 <h4>Funkcja empty()</h4>
                <p>Funkcja empty() sprawdza, czy zmienna jest pusta. Zmienna jest uważana za pustą, jeśli jest równa false w kontekście logicznym (czyli jej wartość jest 0, 0.0, NULL, "", "0", [], lub false). Zwraca true, jeśli zmienna jest pusta, oraz false w przeciwnym razie.</p>
                   <pre><code>{`<?php
$var1 = "";
$var2 = "PHP";
$var3 = 0;

if (empty($var1)) {
    echo "var1 jest pusta.<br>";
} else {
    echo "var1 nie jest pusta.<br>";
}

if (empty($var2)) {
    echo "var2 jest pusta.<br>";
} else {
    echo "var2 nie jest pusta.<br>";
}

if (empty($var3)) {
    echo "var3 jest pusta.<br>";
} else {
    echo "var3 nie jest pusta.<br>";
}
?>`}</code></pre>
<p>Przykłady według definicji:</p>
<pre><code>{`<?php
$var1 = "";
$var2 = NULL;
$var3 = "0";
$var4 = "PHP";

// Zwróci true i true
echo "isset(\$var1): " . (isset($var1) ? "true" : "false") . "<br>";
echo "empty(\$var1): " . (empty($var1) ? "true" : "false") . "<br><br>";

// Zwróci false i true
echo "isset(\$var2): " . (isset($var2) ? "true" : "false") . "<br>";
echo "empty(\$var2): " . (empty($var2) ? "true" : "false") . "<br><br>";

// Zwróci true i true
echo "isset(\$var3): " . (isset($var3) ? "true" : "false") . "<br>";
echo "empty(\$var3): " . (empty($var3) ? "true" : "false") . "<br><br>";

// Zwróci true i false
echo "isset(\$var4): " . (isset($var4) ? "true" : "false") . "<br>";
echo "empty(\$var4): " . (empty($var4) ? "true" : "false") . "<br>";
?>`}</code></pre>

            </section>
          </div>
        </div>
    </div>
  )
}


export default Skrphp